var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _vm._v(" Manage Subdomains "),
          [
            _c("gg-text-field", {
              staticClass: "float-right",
              attrs: {
                outlined: "",
                "append-icon": "mdi-magnify",
                "single-line": "",
                "hide-details": ""
              },
              model: {
                value: _vm.search,
                callback: function callback($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ]
        ],
        2
      ),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              loading: _vm.loading,
              search: _vm.search,
              items: _vm.items
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function fn(_ref2) {
                                var on = _ref2.on,
                                  attrs = _ref2.attrs
                                return [
                                  _c(
                                    "gg-btn",
                                    _vm._g(
                                      _vm._b({}, "gg-btn", attrs, false),
                                      on
                                    ),
                                    [
                                      _vm._v(" Manage "),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1"
                                        },
                                        [_vm._v("mdi-chevron-down")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("redirection", item)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" Manage Redirection ")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("delete", item)
                                  }
                                }
                              },
                              [_c("v-list-item-title", [_vm._v(" Remove ")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm.modals.docroot
            ? _c("change-doc-root-modal", {
                attrs: {
                  "selected-domain": _vm.selectedItem,
                  opened: _vm.modals.docroot
                },
                on: {
                  "docroot-updated": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("docroot")
                  }
                }
              })
            : _vm._e(),
          _vm.modals.delete
            ? _c("delete-subdomain-modal", {
                attrs: {
                  subdomain: _vm.selectedItem,
                  opened: _vm.modals.delete
                },
                on: {
                  "addondomain-removed": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("delete")
                  }
                }
              })
            : _vm._e(),
          _vm.modals.redirection
            ? _c("manage-redirection-modal", {
                attrs: {
                  "hosting-domain": _vm.selectedItem,
                  opened: _vm.modals.redirection
                },
                on: {
                  "redirection-updated": _vm.reload,
                  "redirection-removed": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("redirection")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }